export class PermissionGrant {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "permission",
            "baseName": "permission",
            "type": "PermissionType",
            "format": ""
        },
        {
            "name": "accessConditionId",
            "baseName": "accessConditionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "conditionalScopes",
            "baseName": "conditionalScopes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PermissionGrant.attributeTypeMap;
    }
    constructor() {
    }
}
